export const painPoints = [
  {
    emoji: '🧭',
    title: "You don't know where to start",
    desc: 'The aging process looks impossible and you are overwhelmed by where to begin. This method organizes everything: first cognitive health, then physical strength, then nutrition, then home safety, then caregiver wellness.',
  },
  {
    emoji: '🔤',
    title: 'You get stuck with daily routines (and nothing feels consistent)',
    desc: 'You learn it here the guided way, so you recognize what actually prevents decline and implement with intention. No more confusion between random activities and what actually maintains independence.',
  },
  {
    emoji: '🧩',
    title: "You know your parent needs help but can't build a complete care system",
    desc: 'You learn the complete protocol structure to build plans that actually make sense and start your parent on real vitality from day one.',
  },
  {
    emoji: '💭',
    title: 'You prescribe activities but forget the assessment checkpoints',
    desc: 'You get concrete daily tracking and advancement guidelines so what you implement actually progresses instead of stalling in a week.',
  },
  {
    emoji: '🎯',
    title: 'You manage your parent but fear falls, confusion and hospitalization',
    desc: 'Guessing is dangerous. A clear prevention framework is what keeps your aging parent safe and dignified until they maintain their independence naturally.',
  },
  {
    emoji: '🔁',
    title: 'You started a caregiver course and quit after two weeks',
    desc: "One-off lessons are not progress. A complete 6-volume system with visible milestones is what keeps you going until you manage your parent's aging successfully with confidence.",
  },
];
